import { render, staticRenderFns } from "./imgC.vue?vue&type=template&id=d429c3b8"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d429c3b8')) {
      api.createRecord('d429c3b8', component.options)
    } else {
      api.reload('d429c3b8', component.options)
    }
    module.hot.accept("./imgC.vue?vue&type=template&id=d429c3b8", function () {
      api.rerender('d429c3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgC.vue"
export default component.exports